// extracted by mini-css-extract-plugin
module.exports = {"campaignBanner":"PromoCampaignBanner__campaignBanner","campaignContainer":"PromoCampaignBanner__campaignContainer"};